import { Component, OnInit, Injector, Input, ViewEncapsulation, ChangeDetectorRef, AfterViewChecked, ChangeDetectionStrategy } from '@angular/core';
import { NG_VALUE_ACCESSOR, UntypedFormGroup, Validators, UntypedFormControl } from '@angular/forms';

import type { Editor } from '@ckeditor/ckeditor5-core';
import DecoupledEditor from '@ckeditor/ckeditor5-build-decoupled-document';

import { AppConstants } from '@apps/app.constants';
import { UtilsService } from '@common/services';

import { InputBase } from '../../../base/input-base';

@Component({
    selector: 'aa-input-editor',
    templateUrl: './input-editor.component.html',
    styleUrls: [
        './input-editor.component.scss'
    ],
    providers: [{
            provide: NG_VALUE_ACCESSOR,
            useExisting: InputEditorComponent,
            multi: true,
        }],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class InputEditorComponent extends InputBase<string> implements OnInit,AfterViewChecked
{
    private static identifier = 0;
    @Input() public placeholder: string;
    @Input() public height: number = 20;
    public readonly textField = 'text';
    public configEditor = AppConstants.configEditor;
    public editor: Editor = DecoupledEditor as unknown as Editor;
    public formGroup: UntypedFormGroup;
    public labelOut: boolean = false;
    private formControl: UntypedFormControl;
    private isFocused: boolean = false;

    constructor (
        injector: Injector,
        private changeDetectorRef: ChangeDetectorRef
    )
    {
        super(injector);

        this.fieldId = `input-editor-${InputEditorComponent.identifier++}-id`;
    }

    ngOnInit ()
    {
        this.formControl = new UntypedFormControl(this.value, this.required ? [Validators.required] : []);
        this.formControl.valueChanges.subscribe((value: string) =>
        {
            this.value = value;
            this.labelOut = this.isFocused || !UtilsService.isNullOrEmpty(this.value);
        });

        this.formGroup = new UntypedFormGroup({
            [this.name]: this.formControl
        });
    }

    ngAfterViewChecked ()
    {
        this.changeDetectorRef.detectChanges();
    }

    public onReady (editor: Editor)
    {
        const toolbarElement = (editor.ui.view as any).toolbar.element;

        editor.ui.getEditableElement().parentElement.insertBefore(
            toolbarElement,
            editor.ui.getEditableElement()
        );
        editor.setData(this.value);
        if (!UtilsService.isNullOrEmpty(this.value))
        {
            this.labelOut = true;
        }

        editor.editing.view.document.on('change:isFocused', (evt: any, data: any, isFocused: boolean ) =>
        {
            this.isFocused = isFocused;
            this.labelOut = this.isFocused || !UtilsService.isNullOrEmpty(this.value);
            if (!isFocused)
            {
                this.touch();
            }
        });
    }
}
